import Axios, { AxiosResponse } from "axios";
import defineHeaderAxios from "@/utilities/useAuthToken";
import { ref } from "@vue/composition-api";
export default function () {
    const batteryData = ref<Array<BatteryDataPoint>>([]);
    const getBatteryData = async (
        batteryId: string,
        daysBack: number
    ): Promise<Array<BatteryDataPoint>> => {
        await defineHeaderAxios();
        return Axios.get(`/api/Battery/${batteryId}/${daysBack}`)
            .then((result: AxiosResponse<Array<BatteryDataPoint>>) => {
                if (result.status === 200) {
                    batteryData.value = result.data;
                    return result.data;
                } else return new Array<BatteryDataPoint>();
            })
            .catch((error) => {
                return new Array<BatteryDataPoint>();
            });
    };
    return {
        getBatteryData,
        batteryData,
    };
}

export class BatteryDataPoint {
    voltage: number;
    date: Date;
}
